import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-709f949a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = {
  key: 0,
  class: "popup-wrap",
  ref: "PopUpRef"
}
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "button-with-chevron" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-chevron" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "popup-wrap" }, {
      default: _withCtx(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "content", {}, undefined, true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Tooltip, { text: _ctx.tooltipBtn }, {
        button: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "icon",
            mode: "outlined",
            size: "l",
            icon: { spriteUrl: '/image/videoconf-icons.svg', name: _ctx.name, color: '--sui-gray-700', width: _ctx.size, height: _ctx.size},
            "icon-only": "",
            disabled: _ctx.disabled,
            onClick: _ctx.toggleMedia
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }, 8, ["icon", "disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["text"]),
      _createVNode(_component_Tooltip, {
        class: "button",
        text: _ctx.tooltipChevron
      }, {
        button: _withCtx(() => [
          _createVNode(_component_Button, {
            class: _normalizeClass(["chevron", {'active': _ctx.isActive}]),
            mode: "outlined",
            size: "l",
            disabled: _ctx.disabled,
            onClick: _ctx.toggleClass,
            ref: "PopUpButtonRef"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["class", "disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["text"])
    ])
  ]))
}